<section class="px-4 py-16 md:py-24">
  <div
    class="w-full flex flex-col font-extrabold font-secondary text-6xl sm:text-8xl md:text-10xl lg:text-12xl xl:text-14xl my-6 sm:my-10">
         <h1 i18n="@@autopark.logistics.title" class="text-secondary-650 text-center max-w-[1500px] px-4 mx-auto">
           Logistyka
           <span class="text-primary-500">
             z ProcessWay
           </span>
         </h1>
  </div>
  <div
    class="w-full mx-auto max-w-[1250px] rounded-3xl sm:rounded-[3rem] overflow-hidden bg-secondary-100 shadow-2xl ring-2 ring-secondary-300">
    <div class="mb-8 md:mb-12 px-4 sm:px-8 md:px-16 my-6 md:my-10">
      <p i18n="@@autopark.logistics.description" class="text-secondary-700 text-sm sm:text-base md:text-lg text-left leading-relaxed">
        Proces obsługi pojazdów na placu depozytowym AutoPark Processway został zaprojektowany tak, aby zapewnić
        maksymalną powtarzalność, transparentność i pełną kontrolę nad każdym etapem relokacji – od momentu awizacji
        transportu, przez wjazd lawety i rozładunek, aż po późniejsze magazynowanie oraz wydanie pojazdu do dalszej
        operacji logistycznej. Wszystkie czynności są realizowane w trybie on-line, z jednoznacznym przypisaniem
        odpowiedzialności i minimalizacją czasu postoju transportu.
      </p>
      <div class="w-full h-fit inline-flex justify-center my-5">
        <p-button
          (click)="onCtaClick()"
          i18n-label="@@button.check-it-out"
          label="Sprawdzam"
          class="extra-padding mt-5"
          [rounded]="true"
          [navigator]="formComponentSignal()?.id">
        </p-button>
      </div>
    </div>

    <div class="mb-8 md:mb-12 px-4 sm:px-8 md:px-16">
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-6 lg:gap-4 relative">
        @for (step of steps; track step.title; let i = $index) {
          <div class="relative h-fit lg:h-[250px]">
            <div
              class="bg-secondary-400 h-full rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 relative z-10">
              <div
                class="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary-500 text-white font-bold text-base sm:text-lg mb-3 sm:mb-4">
                {{ i + 1 }}
              </div>
              <h3 class="text-lg sm:text-xl font-secondary font-semibold text-secondary-900 mb-2 sm:mb-3">
                {{ step.title }}
              </h3>
              <p class="text-secondary-700 text-xs sm:text-sm leading-relaxed">
                {{ step.description }}
              </p>
            </div>

            @if (i < steps.length - 1) {
              <div
                class="hidden lg:flex absolute top-1/2 right-0 translate-y-[-50%] translate-x-[calc(50%+0.5rem)] z-20 w-12 h-12 rounded-full bg-secondary-100 text-primary-500 items-center justify-center">
                <ng-icon name="matChevronRightRound" size="2.5rem"></ng-icon>
              </div>

              <div
                class="flex lg:hidden absolute left-1/2 bottom-0 -translate-x-[50%] translate-y-[calc(50%+0.75rem)] z-20 items-center justify-center w-12 h-12 rounded-full bg-secondary-100 text-primary-500">
                <ng-icon name="matKeyboardArrowDownRound" size="2.5rem"></ng-icon>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <img src="assets/parking/images/car-towing-truck.webp"
         alt="car-towing-truck"
         class="w-full h-auto object-cover mask-b-from-10% mask-b-to-100% translate-y-[15%]">
  </div>
</section>
